import Bugsnag from "@bugsnag/js";
import { client } from "@nju/http-client";
import { ICancelOrderResult, IReason, IReasonDetails } from "./types";
import { ok } from "@nju/result";

interface ICancelChangeSimEsimProps {
  reason: IReason;
  orchestratorId: string;
  reasonDetails?: IReasonDetails;
}

export async function cancelChangeSimEsim(
  props: ICancelChangeSimEsimProps
): Promise<ICancelOrderResult> {
  const { orchestratorId, ...json } = props;

  const result = await client(
    `${process.env.NEXT_PUBLIC_PUBLIC_GATEWAY_HOST}/orchestrators/${orchestratorId}/actions/ORDER_CANCEL`,
    {
      method: "post",
      headers: {
        version: "2",
        apikey: process.env.NEXT_PUBLIC_APIKEY || "unknown",
      },
      json,
    }
  );

  if (result.isError) {
    Bugsnag.notify(result.err);
    return result;
  }

  return ok(undefined);
}
